@if (routeLoading()) {
  <div class="fixed inset-x-0 top-0 z-[100000] h-1 overflow-hidden bg-brand-500/15" aria-hidden="true">
    <div class="cms-route-progress h-full w-1/3 bg-brand-500"></div>
  </div>

  <div
    class="fixed right-4 top-4 z-[100001] flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900"
    role="status"
    aria-live="polite"
  >
    <span class="cms-spinner" aria-hidden="true"></span>
  </div>
}

<router-outlet />
